import React, { FC, useContext } from 'react'

import { Controller, useFormContext } from 'react-hook-form'

import { AppContext } from 'Const'

import ErrorMessage from 'Components/ErrorMessage'
import PhoneInput from 'Components/PhoneInput'

import FormErrors from '../../FormErrors'

interface Props {
  disabled?: boolean
}

const Phone: FC<Props> = ({ disabled }) => {
  const { control, errors } = useFormContext()
  const { locationCountryIsoCodes } = useContext(AppContext)
  const defaultCountry = locationCountryIsoCodes[0] || 'US'
  return (
    <div className="d-flex align-items-center mb-2">
      <label className="col-sm-4 mb-0" htmlFor="customer-phone">
        Phone
      </label>
      <Controller
        control={control}
        name="phone"
        render={(props) => (
          <PhoneInput
            {...props}
            required
            addInternationalOption={false}
            autoComplete="tel"
            countryOptionsOrder={locationCountryIsoCodes}
            defaultCountry={defaultCountry}
            disabled={disabled}
            id="customer-phone"
            numberInputProps={{ className: 'form-control' }}
          />
        )}
        rules={{ required: 'Phone is required' }}
      />
      <ErrorMessage as={FormErrors} errors={errors} name="phone" />
    </div>
  )
}

export default Phone
